import { render, staticRenderFns } from "./DriverGroups.vue?vue&type=template&id=0c1e3650&"
import script from "./DriverGroups.vue?vue&type=script&lang=js&"
export * from "./DriverGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports